import { Avatar as CompassAvatar } from "@circleco/compass/components/Avatar";

import { isAuthorAiAgent } from "@/react/components/CommentsCompass/helpers";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";
import { AiAgentProfileHoverCard } from "@/react/components/Profile/AiAgentHoverCard";
import { ProfileHoverCard } from "@/react/components/Profile/HoverCard";
import { cssAnchorProps } from "@/react/helpers/cssAnchorHelpers";
import type { Comment } from "@/react/types/Comment";

import { useAuthorLinkProps } from "./useAuthorLinkProps";

interface AvatarProps {
  comment: Comment;
}

export const Avatar = ({ comment }: AvatarProps) => {
  const { community_member: communityMember } = comment;
  const linkProps = useAuthorLinkProps(comment);
  const isAiAgent = isAuthorAiAgent(comment);
  const { isEmbedded } = useCommentsConfig();

  const HoverCard = isAiAgent ? AiAgentProfileHoverCard : ProfileHoverCard;

  return (
    <HoverCard
      communityMemberId={communityMember.id}
      name={communityMember.name}
      publicUid={communityMember.public_uid}
      headline={isAiAgent ? undefined : communityMember.headline}
      avatarURL={communityMember.avatar_url}
      disabled={isEmbedded}
    >
      <CompassAvatar
        size="md"
        name={communityMember.name}
        src={communityMember.avatar_url}
        aria-label={communityMember.name ?? ""}
        renderLink={
          <a {...linkProps} {...cssAnchorProps({ anchor: "comment-avatar" })} />
        }
      />
    </HoverCard>
  );
};
